import {
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  DollarOutlined,
  MessageOutlined,
  PhoneOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';

function buildMenu(user) {
  const profile = { id: 'profile', title: 'profile.myProfile', type: 'item', url: '/profile', icon: UserOutlined };
  const conversations = {
    id: 'sales-conversations',
    title: 'nav.conversations',
    type: 'item',
    url: '/sales-conversations',
    icon: MessageOutlined
  };

  if (user?.role === 'platform_sales') {
    return {
      items: [
        {
          id: 'group-sales',
          title: 'nav.administration',
          type: 'group',
          children: [conversations, profile]
        }
      ]
    };
  }

  return {
    items: [
      {
        id: 'group-ops',
        title: 'nav.administration',
        type: 'group',
        children: [
          { id: 'tenants', title: 'nav.tenants', type: 'item', url: '/tenants', icon: BankOutlined },
          conversations,
          { id: 'prospects', title: 'nav.prospecting', type: 'item', url: '/prospects', icon: PhoneOutlined },
          { id: 'industries', title: 'nav.industries', type: 'item', url: '/industries', icon: AppstoreOutlined },
          { id: 'ai', title: 'settings.menu.ai', type: 'item', url: '/ai', icon: SettingOutlined },
          { id: 'credits', title: 'settings.menu.platformCredits', type: 'item', url: '/credits', icon: DollarOutlined },
          { id: 'credit-pricing', title: 'settings.menu.creditPricing', type: 'item', url: '/credit-pricing', icon: DollarOutlined },
          { id: 'audit-log', title: 'nav.auditLog', type: 'item', url: '/audit-log', icon: AuditOutlined },
          profile
        ]
      }
    ]
  };
}

export default buildMenu;
